import { ModalComponentNames, ModalInterface } from '../Interfaces/ModalInterface';
import { NAVIGATION } from './actionTypes';
import { actionCreator } from './index';

export const navigateAddModal = actionCreator<ModalInterface>(NAVIGATION.ADD_MODAL);
export const navigateRemoveModal = actionCreator<ModalComponentNames>(NAVIGATION.REMOVE_MODAL);
